import * as PIXI from "pixi.js";
import { brightnessFilter } from "../Game/global";


export default function addInteraction(
    button: PIXI.Container,
    onHandleTapFunc: () => void,
    scaleChildren: boolean
  ) {
  button.interactive = true;
  button.cursor = "pointer";
  button
    .on("pointertap", () => onHandleTapFunc())
    .on("pointerover", () => button.filters = [brightnessFilter]) 
    .on("pointerout",() => {
      button.filters = [] ;
      setScale(1)
    })
    .on("pointerdown", () => setScale(.95))
    .on("pointerup", () => setScale(1))
    .on("pointerupoutside", () => setScale(1));

    const setScale = (scale: number) => {
      if(scaleChildren) {
        return button.children.forEach(ele => ele.scale.set(scale))
      }
      button.scale.set(scale);
    }
}